import type {EmailCampaignPublishOptionsSublow} from '@Components/email-marketing-campaigns/email-marketing-campaigns.types';
import {useAppSelector} from '@/hooks';

export const useEmailPublishingDialogSubflow = (): EmailCampaignPublishOptionsSublow => {
  return useAppSelector((state): EmailCampaignPublishOptionsSublow => {
    return state.emailCampaignPublishOptions.publishingSubflow;
  });
};
